<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col lg="12">
        <b-card>
          <div class="row">
            <div class="col">
              <Filters
                :filters="filters"
                :applying="applying"
                v-on:apply="apply()"
                :hideCompany="filterDisplay.hideCompany"
                :hideRegion="filterDisplay.hideRegion"
                :hideBranch="filterDisplay.hideBranch"
                :hideDevice="filterDisplay.hideDevice"
                :hideDate="filterDisplay.hideDate"
              ></Filters>
            </div>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <b-card>
          <div class="card-header">
            <i class="fa fa-align-justify"></i> Region Report
          </div>
          <div v-if="applying" class="table-loading-container">
            <img
              src="/img/wifi-loading.gif"
              alt="loading"
              class="loading-table"
            />
          </div>
          <div v-if="!applying">
            <table class="table table-striped" v-if="regionReport.length">
              <thead>
                <tr>
                  <th>Region</th>
                  <th class="text-center">New Users</th>
                  <th class="text-center">Returning Users</th>
                  <th class="text-center">Unique Visits</th>
                  <th class="text-center">Total Visits</th>
                  <th class="text-center">Avg. Visit / User</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="item in regionReport" :key="item.id">
                  <td>
                    {{ item.regionName }}
                  </td>
                  <td class="text-center">
                    {{ item.registerUsers }}
                  </td>
                  <td class="text-center">
                    {{ item.uniqueUsers - item.registerUsers }}
                  </td>
                  <td class="text-center">
                    {{ item.uniqueUsers }}
                  </td>
                  <td class="text-center">
                    {{ item.visitUsers }}
                  </td>
                  <td class="text-center">
                    {{ (item.visitUsers / item.uniqueUsers) | roundAverage }}
                  </td>
                </tr>
              </tbody>
            </table>
            <button
              class="btn btn-dark pull-right"
              type="button"
              @click="exportData()"
            >
              Export Data
            </button>
            <a
              :href="latestDownloadLink"
              ref="downloadLink"
              style="display:none;"
              >Download {{ exportFileName }}</a
            >
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import axios from "axios";
import common from "./../../mixins/common";
import filter from "./../../mixins/filter";
import Filters from "@/views/common/Filters";

export default {
  name: "regionreport",
  components: {
    Filters
  },
  mixins: [common, filter],
  data() {
    return {
      applying: false,
      selectedItem: {},
      deleteModal: false,
      filters: {
        company: null,
        region: null,
        branch: null,
        device: null,
        fromDate: "",
        toDate: "",
        exportData: false
      },
      regionReport: [],
      exportFileName: null
    };
  },
  computed: {
    downloadLink() {
      return this.$refs.downloadLink;
    },
    filterReady() {
      return (
        this.filters.company !== null &&
        this.filters.fromDate !== "" &&
        this.filters.todate !== null
      );
    },
    latestDownloadLink() {
      if (this.exportFileName) {
        return `/exports/${this.exportFileName}`;
      }
      return null;
    }
  },
  methods: {
    apply() {
      let scope = this;
      if (scope.validate()) {
        scope.applying = true;

        if (scope.filters.allTime) {
          scope.filters.fromDate = scope.$store.getters.allTime.fromDate;
          scope.filters.toDate = scope.$store.getters.allTime.toDate;
        }

        scope.$store.dispatch("getRegionReport", scope.filters).then(
          result => {
            scope.regionReport = result.results;
            scope.exportFileName = result.exportFileName;
            scope.applying = false;
            if (scope.exportFileName) {
              //wait for a link dom element
              setTimeout(() => {
                const elemDown = scope.$refs.downloadLink;
                elemDown.click();
              }, 1000);
            }
          },
          error => {
            console.log(error);
            scope.applying = false;
          }
        );
      }
    },
    validate() {
      if (this.filters.fromDate === "" || this.filters.toDate === "") {
        this.showToast("Select a valid date range", "error");
        return false;
      }
      return true;
    },
    exportData() {
      this.filters.exportData = true;
      this.apply();
    }
  },
  created() {
    this.filterDisplay.hideRegion = true;
    this.filterDisplay.hideBranch = true;
    this.filterDisplay.hideDevice = true;
    this.filterDisplay.hideDate = false;
    this.setupFilter();
    setTimeout(() => {
      this.apply();
    }, 1000);
  }
};
</script>
